import React, { useEffect, useState, useRef } from 'react';
import { stateToHTML } from 'draft-js-export-html';
import { EditorState, RichUtils, DraftHandleValue } from 'draft-js';
import { FaWandMagicSparkles } from "react-icons/fa6";
import LcIcon from '../../Generic/LcIcon';
import "./index.css";
import { PPDropDown } from 'processor-plataform-ui';
import { useSelector } from 'react-redux';
import { MenuState } from '../../../store/reducers/menuReducer';
import { RootState } from '../../../store/index';
import LcIconLink from '../../Generic/LcIconLink';
import ScriptEditor from './ScriptEditor';
import LcTooltip from '../../Generic/LcTooltip';
import { UserState } from '../../../store/reducers/userReducer';
import GenerativeIaEvaluationService from "../../../services/GenerativeIaEvaluationService/GenerativeIaEvaluationService";
import moment from 'moment';

interface Props {
    label?: string,
    onChange: Function,
    value: any,
    openAttachment: Function,
    handleFiles?: Function
    files?: any,
    removeFiles?: Function,
    placeholder?: string
    // attendant?: boolean
    comment?: boolean
    setCommentType?: Function
    handleClick?: Function
    setToolbar?: Function
    emailTemplates?: any[]
    setCommentTemplateSelected?: Function
    mentions?: any
    userMention: Function,
    removeMention?: Function
    selectedMentions?: any
    removedMention?: any
    refreshRemoved?: Function
    solicitation: any
    comments?: any[]
}

interface Option {
    label: any,
    value: string
}

const HHRichTextBoxDraftAttendant: React.FC<Props> = (props) => {
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const user = useSelector<RootState, UserState>(state => state.user);
    const generativeIaEvaluationService = new GenerativeIaEvaluationService(props);
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
    const [showToolBar, setShowToolBar] = useState<boolean>(false);
    const [optionsValue, setOptionsValue] = useState("1");
    const [visualization, setVisualization] = useState(1);
    const [sugestaoExp, setSugestaoExp] = useState<boolean>(false);
    const [commentSummaryVisible, setCommentSummaryVisible] = useState<boolean>(false)
    const [htmlString, setHtmlString] = useState('');
    const [activeTemplate, setActiveTemplate] = useState<boolean>(false);
    const [text, setText] = useState('');
    const [hiddenSpan, setHiddenSpan] = useState<boolean>(false);
    const [options, setOptions] = useState<Option[]>(
        // [
        //     {
        //         label: <span className={"spanOrderIconCommentType"}>
        //             <i className="ppi ppi-eye-off iconCommentType" />
        //             Visivel para o atendente somente
        //         </span>,
        //         value: "0"
        //     },
        //     {
        //         label: <span className={"spanOrderIconCommentType"}>
        //             <i className="ppi ppi-eye iconCommentType" />
        //             Visivel para o solicitante
        //         </span>,
        //         value: "1"
        //     },
        //     {
        //         label: <span className={"spanOrderIconCommentType"}>
        //             <i className="ppi ppi-mail-open iconCommentType" />
        //             Enviar e-mail padrão para o cliente
        //         </span>,
        //         value: "3"
        //     }
        // ]
    )

    const [emailTemplateSelected, setEmailTemplateSelected] = useState<any>(undefined);
    const [emailTemplates, setEmailTemplates] = useState<any[]>([]);
    const [activeAi, setActiveAi] = useState<any>();

    useEffect(() => {
        if ((text.length === 0 || text === '<p style="font-size: 13.3333px;"><br></p>') && emailTemplateSelected) {
            setEmailTemplateSelected(undefined);
            props.setCommentTemplateSelected && props.setCommentTemplateSelected(undefined);
        }
    }, [text]);

    useEffect(() => {
        props.setCommentType && props.setCommentType(visualization)
    }, [visualization]);

    useEffect(() => {
        if (props.emailTemplates && props.emailTemplates.length > 0) {
            setEmailTemplates(mountDropList(props.emailTemplates));
        }
    }, [props.emailTemplates]);

    useEffect(() => {
        CheckAiConfig();

        if (props.value) {
            setText(props.value);
        }
    }, []);

    useEffect(() => {
        props.setToolbar && props.setToolbar(showToolBar);
    }, [showToolBar]);

    useEffect(() => {
        if (showToolBar === false) {
            setSugestaoExp(false);
        }
    }, [showToolBar]);

    useEffect(() => {
        if (emailTemplateSelected) {
            setText(emailTemplateSelected.text);
            props.setCommentTemplateSelected && props.setCommentTemplateSelected(emailTemplateSelected);
        }
        else {
            props.setCommentTemplateSelected && props.setCommentTemplateSelected(undefined);
        }
    }, [emailTemplateSelected]);

    const CheckAiConfig = async () => {
        try {
            const response = await generativeIaEvaluationService.CheckAiConfig(props.solicitation.id);
            setActiveAi(response.data);
        }
        catch (error) {
            console.log(error)
        }
    }

    const mountDropList = (list: any[]) => {
        let result = (list.length === 1) ? [] : [{ label: "Modelo padrão", value: '0' }];

        if (list.length > 0) {
            let _list = list.filter(c => (c.disabled) ? c.disabled === 0 || c.disabled === false : c)
                .map(c => { return { label: c.description, value: c.id } })
                .sort((a, b) => { return a.label > b.label ? 1 : -1 });

            return [..._list];
        }
        else {
            return result;
        }
    }

    const [optionsFormatedType, setOptionsFormatedType] = useState<any>({
        bold: false,
        italic: false,
        strikeThrough: false,
    });

    const onBoldClick = (e) => {
        e.preventDefault();
        // setEditorState(RichUtils.toggleInlineStyle(editorState, 'BOLD'));
        setOptionsFormatedType({
            ...optionsFormatedType,
            bold: !optionsFormatedType.bold
        });
    }

    const onItalicClick = (e) => {
        e.preventDefault();
        // setEditorState(RichUtils.toggleInlineStyle(editorState, 'ITALIC'));
        setOptionsFormatedType({
            ...optionsFormatedType,
            italic: !optionsFormatedType.italic
        });
    }

    const onUnderlineClick = (e) => {
        e.preventDefault();
        // setEditorState(RichUtils.toggleInlineStyle(editorState, 'UNDERLINE'));

    }

    const onStrikeThroughClick = (e) => {
        e.preventDefault();
        // setEditorState(RichUtils.toggleInlineStyle(editorState, 'STRIKETHROUGH'));
        setOptionsFormatedType({
            ...optionsFormatedType,
            strikeThrough: !optionsFormatedType.strikeThrough
        });
    }

    const handleKeyCommand = (command, editorState) => {
        const newState = RichUtils.handleKeyCommand(editorState, command);

        if (newState) {
            setEditorState(newState);
            return 'handled';
        }

        return 'not-handled';
    }

    const handleChange = (e: any) => {
        setEditorState(e);
        (props.comment)
            ? props.onChange(editorState)
            : props.onChange(stateToHTML(editorState.getCurrentContent()));
    }

    const handleFiles = (files: Blob[], event?: any,): DraftHandleValue => {
        if (files && props.handleFiles) {
            props.handleFiles(files)
            return "handled";
        }
        else {
            return "not-handled";
        }
    }

    const handleClick = () => {
        var _text = text
            .replaceAll("<br >", " \n ")
            .replaceAll("<br>", " \n ")
            .replaceAll("<br/>", " \n ")
            .replaceAll("<br />", " \n ");

        if (_text.length > 4000 && !emailTemplateSelected) {
            setHiddenSpan(true);
            return;
        }

        if (_text !== "") {
            props.handleClick && props.handleClick(_text);
        }
        else if (props.files.length > 0) {
            props.handleClick && props.handleClick("");
        }
    }
    const handleChangeTemplate = (event: any) => {
        const { value } = event.target;
        const emailTemplate = props.emailTemplates?.find(x => x.id === Number(value));

        if (!emailTemplate) {
            return;
        }

        let replacements: any = {
            "{ SOLICITACAO }": props.solicitation.id,
            "{SOLICITACAO}": props.solicitation.id,
            "chamado XXXX": `chamado ${props.solicitation.id}`,
            '<span style="background-color: #ffff00;">xxxxxx</span>': `${props.solicitation.id} <br />`,
            '<span style="background-color: #ffff00;">XXXXXX <br /> </span>': `${props.solicitation.id} <br />`,
            '{ CLIENTE }': props.solicitation.nameCustomer,
            '{CLIENTE}': props.solicitation.nameCustomer,
            '<span style="background-color: #ffff00;">(Inserir Nome do Cliente)</span>': props.solicitation.nameCustomer,
            '{ DETALHAMENTO }': props.solicitation.details,
            '{DETALHAMENTO}': props.solicitation.details,
            '<span style="background-color: #ffff00;">Inserir descrição</span>': props.solicitation.details,
            '<span style="background-color: #ffff00;">Nome do solicitante</span>': props.solicitation.nameUserRequester,
            '{  DATA_HORA  }': moment(props.solicitation.registrationDate).format("DD/MM/YYYY : hh:mm"),
            '<span style="background-color: #ffff00;">DD/MM</span>': moment(props.solicitation.slaResponseDate).format("DD/MM"),
        };

        if (props.solicitation.requesterPhone != null && props.solicitation.requesterPhone !== "") {
            replacements = {
                ...replacements,
                'telefone (xx) xxxx-xxxx': `telefone ${props.solicitation.requesterPhone}`,
                'telefone <span style="background-color: #ffff00;">(xx) xxxx-xxxx</span>': `telefone ${props.solicitation.requesterPhone}`,
            }
        }

        let { text } = emailTemplate;

        for (const [key, value] of Object.entries(replacements)) {
            text = text.replace(key, value);
        }

        emailTemplate.text = text;
        setEmailTemplateSelected(emailTemplate);
    };

    const getWidthTextBox = () => {
        if (showToolBar) {
            return "calc(100% - 1px)";
        }
        else {
            return "calc(100% - 1px)";
        }
    }
    const handleRemoveFiles = (files) => {
        props.removeFiles && props.removeFiles(files);
    }

    const pasteImage = async (event) => {
        if (props.handleFiles) {
            var item = event.clipboardData?.items[0];

            if (item && item.type.indexOf("image") === 0) {
                var blob = item.getAsFile();
                var reader = new FileReader();

                blob && reader.readAsDataURL(blob);
                props.handleFiles([blob]);
            }
        }
    }

    const Attachments = () => {
        const removeFile = (index: number) => {
            const updatedFiles = [...props.files];
            updatedFiles.splice(index, 1);
            handleRemoveFiles(updatedFiles);
        };

        const formatBytes = (bytes, decimals = 2) => {
            if (bytes === 0) return '0 Bytes';

            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }

        return (
            <>
                {
                    props.files && props.files.length > 0 &&
                    <div className={"divOrderAttachmentComments"}>
                        {
                            props.files && props.files.map((file, index) => {
                                let size = formatBytes(file.size);

                                return (
                                    <div className='divShowfile' >
                                        <LcIcon
                                            icon={"ppi ppi-paper-clip"}
                                            size={"small"}
                                            color={'#898DA6'}
                                        />
                                        <div className="divOrderAttachmentShowCommentAttendant">
                                            <span className={"spanLabelCommentAttendant"}>{file.name}</span>
                                            <span className={"spanSize"}>{size}</span>
                                        </div>
                                        <LcIconLink
                                            icon={"ppi ppi-x"}
                                            tooltip={"Remover"}
                                            size={"small"}
                                            onClick={() => removeFile(index)}
                                            color={"red"}
                                        />
                                    </div>
                                )
                            })
                        }
                    </div>
                }
            </>
        )
    }

    const getWidthEditor = () => {
        if (showToolBar) {
            return "calc(100% - 83px)";
        }

        if (user && user.defaultCustomer.id === 2) {
            return "calc(100% - 330px)";
        }

        return "calc(100% - 300px)";
    }

    const getWidthDivOrderRichTextButtons = () => {
        if (showToolBar) {
            return "calc(100% - 80px)";
        }

        // if (user && user.defaultCustomer.id === 2) {
        //     return "110px";
        // }

        return "110px";
    }

    return (
        <>
            <Attachments />
            {
                hiddenSpan &&
                <div className={"spanHidden"} style={{ display: "flex" }}>
                    <span> Texto muito grande. Por favor envie como anexo</span>
                </div>
            }

            <div className={`divOrderRichTextBox`}
                style={{
                    width: getWidthTextBox(),
                    flexDirection: (showToolBar) ? "column" : "row",
                    flexWrap: (showToolBar) ? "wrap" : "nowrap",
                    height: (!showToolBar) ? '50px' : "196px",
                    display: 'flex',
                    alignItems: 'flex-start'
                }}
            >
                <div
                    className={"divOrderRichTextButtons"}
                    style={{
                        width: getWidthDivOrderRichTextButtons(),
                        display: 'flex',
                        alignContent: 'center',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        height: '50px',
                    }}>
                    <div style={{ display: 'flex', marginLeft: '10px' }}>
                        <div className='btnIconsNew'>
                            <LcTooltip
                                trigger={"hover"}
                                content={(showToolBar) ? 'Ocultar barra de ferramentas' : 'Mostrar barra de ferramentas'}
                                position={"top"}
                                top={true}
                            >
                                <div className={`div_anexoHoverTextbox ${(showToolBar) ? "active" : ""}`} onClick={() => setShowToolBar(!showToolBar)}>
                                    <i className={`anexoHoverTextbox ${(!showToolBar) ? "ppi ppi-chevron-up" : "ppi ppi-chevron-down"} ${(showToolBar) ? "active" : ""}`} style={{ fontSize: "25px" }} />
                                </div>
                            </LcTooltip>

                            <LcTooltip
                                trigger={"hover"}
                                content={"Anexar arquivos"}
                                position={"top"}
                                top={true}
                            >
                                <div className={"div_anexoHoverTextbox"} onClick={() => props.openAttachment(true)}>
                                    <i className={"anexoHoverTextbox ppi ppi-paper-clip"} style={{ fontSize: "25px" }} />
                                </div>
                            </LcTooltip>
                            {
                                showToolBar &&
                                <div style={{ margin: '0 5px', cursor: 'pointer' }}>
                                    <LcIconLink
                                        tooltip={(visualization === 1) ? 'Mostrar para solicitante' : 'Mostrar para atendente'}
                                        icon={(visualization === 1) ? 'anexoHoverTextbox ppi ppi-eye' : 'anexoHoverTextbox ppi ppi-eye-off'}
                                        onClick={() => (visualization === 0) ? setVisualization(1) : setVisualization(0)}
                                    />
                                </div>

                            }
                        </div>

                        {
                            emailTemplates.length > 0 && showToolBar &&
                            <PPDropDown
                                options={emailTemplates}
                                value={emailTemplateSelected && emailTemplateSelected.id}
                                name={"emailTemplateId"}
                                onChange={handleChangeTemplate}
                                width={"25vw"}
                                placeholder={'Modelo padrão'}
                                placeholderSearch={"Buscar modelo padrão"}
                            />
                        }
                        {
                            showToolBar &&
                            <>
                                <LcIcon icon={"ppi ppi-divider-vertical"} color={"#B5B7C6"} />
                                <div className={`div_anexoHoverTextbox ${(optionsFormatedType.bold) ? "active" : ""}`} onClick={(e) => onBoldClick(e)}>
                                    <button className={`buttonTextBox ${(optionsFormatedType.bold) ? "active" : ""}`}> B </button>
                                </div>

                                <div className={`div_anexoHoverTextbox ${(optionsFormatedType.italic) ? "active" : ""}`} onClick={(e) => onItalicClick(e)}>
                                    <button className={`buttonTextBox buttonTextBoxItalic ${(optionsFormatedType.italic) ? "active" : ""}`}> I </button>
                                </div>

                                <div className={`div_anexoHoverTextbox ${(optionsFormatedType.strikeThrough) ? "active" : ""}`} onClick={(e) => onStrikeThroughClick(e)}>
                                    <button className={`buttonTextBox buttonTextBoxStrikethrough ${(optionsFormatedType.strikeThrough) ? "active" : ""}`}> S </button>
                                </div>
                            </>
                        }
                    </div>

                    <div style={{ display: 'flex' }}>
                        <div className='btnEnviar'>
                            <button
                                className={"lc-button small bg-info buttonAddDestinatarios"}
                                style={{
                                    marginRight: '10px',
                                    width: "100px",
                                    position: (showToolBar) ? "initial" : 'absolute',
                                    right: (showToolBar) ? "0" : '80px',
                                    top: (showToolBar) ? "0" : (props.files.length > 0) ? "" : '5px',
                                    bottom: (props.files.length > 0) ? "5px" : '0',
                                }}
                                onClick={handleClick}
                            > Enviar </button>
                        </div>
                    </div>
                </div>

                <div
                    className={`textBoxEditorAttendant  scrollable-v`}
                    style={{
                        overflowY: (!showToolBar) ? "hidden" : 'auto',
                        overflowX: "hidden",
                        width: getWidthEditor(),
                        height: (!showToolBar) ? '40px' : "145px",
                        display: (!showToolBar) ? 'flex' : "initial",
                        alignItems: 'center',
                        border: "1px solid gray",
                        borderRadius: '5px',
                        alignContent: 'center',
                        margin: (!showToolBar) ? "auto 0" : "0",
                        padding: '5px 10px',
                        cursor: (showToolBar) ? "text" : "pointer"
                    }}

                    onClick={(e) => {
                        if (props.comment) {
                            setShowToolBar(true);
                            e.stopPropagation();
                        }
                        else {
                            return "";
                        }
                    }}
                    onPaste={pasteImage}
                >
                    <ScriptEditor
                        text={text}
                        setText={setText}
                        useTextOptions={props.comment}
                        placeholder={props.placeholder}
                        showToolBar={showToolBar}
                        optionsFormatedType={optionsFormatedType}
                        userMention={props.userMention}
                        selectedMentions={props.selectedMentions}
                        removedMention={props.removedMention}
                        mentions={props.mentions}
                        removeMention={props.removeMention}
                        refreshRemoved={props.refreshRemoved}
                        user={user}
                        solicitation={props.solicitation}
                        suggestion={activeAi && activeAi.configSuggestion && showToolBar}
                        suggestionStyle={{
                            position: "relative",
                            left: "calc(98% - 1vw)",
                            top: "8vh",
                            zIndex: "9",
                            background: "white",
                            width: "40px",
                            borderRadius: "40px"
                        }}
                        textboxStyle={{
                            width: (showToolBar) ? "97%" : "100%",
                            overflow: (showToolBar) ? "" : "hidden",
                        }}
                    />
                </div>
            </div>
        </>
    );
};

export default HHRichTextBoxDraftAttendant;